module.exports = __webpack_public_path__ + "static/media/fbtb_figma.39cbf24d.png";